import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Paper,
  TableContainer,
  CircularProgress,
  Typography,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Snackbar,
  Alert,
  Tooltip,
  Chip,
  Divider,
} from "@mui/material";
import ParticipantDetailsDialog from "./ParticipantDetailsDialog";
/* import Person from "../formModels/Person";
import PersonSingle from "../formViews/PersonSingle";
import SimpleTextField from "../formViews/SimpleTextField";*/
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
// import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import RemoveRoadIcon from '@mui/icons-material/RemoveRoad';
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { USER_ACTIONS, isAllowedAction } from "../config/auth";
import { useNavigate } from "react-router-dom";

import {
  PARTICIPANT_FORM_SUBMITION,
  PARTICIPANT_APPROVAL_API,
  PARTICIPANT_WITHDRAW_API,
  PARTICIPANT_SUSPEND_API,
  PARTICIPANT_FORM_SCHEMA,
  PARTICIPANT_EVALUATE_STATUS_CHANGE_API,
  PARTICIPANT_UNSUSPEND_API,
  PARTICIPANT_REOPEN_API,
  PARTICIPANT_EXPORT_API,
} from "../config/settings";
import {parseErrorData} from "../config/commonFunctions";

import { DataGrid } from '@mui/x-data-grid';
/* import {
  getTitleByField,
  getDescriptionByField,
} from "../config/commonFunctions"; */

const ParticipantList = () => {
  const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [approveData, setApproveData] = useState({});
  const [schemaAsObject, setSchemaAsObject] = useState({});
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [dialogRejectOpen, setDialogRejectOpen] = useState(false);
  const [dialogSuspendOpen, setDialogSuspendOpen] = useState(false);
  const [dialogRequestSuspendOpen, setDialogRequestSuspendOpen] = useState(false);
  const [dialogRequestUnSuspendOpen, setDialogRequestUnSuspendOpen] = useState(false);
  const [dialogWithdrawOpen, setDialogWithdrawOpen] = useState(false);
  const [dialogRequestWithdrawOpen, setDialogRequestWithdrawOpen] = useState(false);
  const [suspendReinstateDialogOpen, setSuspendReinstateDialogOpen] = useState("");
  const [withdrawReinstateDialogOpen, setWithdrawReinstateDialogOpen] = useState("");
  const [dialogApproveOpen, setDialogApproveOpen] = useState(false);
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [suspendReason, setSuspendReason] = useState("");
  const [withdrawReason, setWithdrawReason] = useState("");
  const [suspendRequestReason, setSuspendRequestReason] = useState("");
  const [suspendDecision, setSuspendDecision] = useState("");
  const [unSuspendRequestReason, setUnSuspendRequestReason] = useState("");
  const [unSuspendDecision, setUnSuspendDecision] = useState("");
  const [withdrawRequestReason, setWithdrawRequestReason] = useState("");
  const [withdrawDecision, setWithdrawDecision] = useState("");
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [selectedParticipantObj, setSelectedParticipantObj] = useState(null);
  const [menuParticipant, setMenuParticipant] = useState(null);
  // Track form validation
  const [isFormValid, setIsFormValid] = useState(false);
  const language = "en";
  const open = Boolean(anchorEl);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const statusColors = {
    APPROVED: "success",
    REJECTED: "error",
    SUSPENDED: "warning",
    WITHDRAWN: "secondary",
    PENDING: "info"
  };
  //"default" "primary" "secondary" "error" "warning" "info" "success"

  const requestedColors = {
    REQUESTED_SUSPENSION: "warning",
    NO_REQUEST: "default",
    REQUESTED_WITHDRAWAL: "secondary",
    REQUESTED_UNDO_SUSPENSION: "warning",
  };

  const fetchSchema = async () => {
    const url = PARTICIPANT_FORM_SCHEMA + language + "/";
    const response = await axios.get(url);
    setSchemaAsObject(response.data);
    // console.log("Fetched Schema:", response.data);
  };

  const fetchParticipants = async () => {
    try {
      const response = await axios.get(PARTICIPANT_FORM_SUBMITION);
      const sortedParticipants = response.data.sort((a, b) => {
        const nameA = a.name.find((n) => n.language === language)?.value || '';
        const nameB = b.name.find((n) => n.language === language)?.value || '';
        return nameA.localeCompare(nameB);
      });
      setParticipants(sortedParticipants);
      // console.log("Fetched Participants:", response.data);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParticipants();
    fetchSchema();
  }, []);

  const handleNameClick = (participant) => {
    setSelectedParticipantObj(participant); // Store the entire participant object
    setDetailsDialogOpen(true);
  };

  const handleDetailsDialogClose = () => {
    setDetailsDialogOpen(false);
  };

  const handleEdit = (participant) => {
    // console.log(participant, menuParticipant);
    navigate(`/participant-form/${participant.id}`, { state: { participant } });
  };

  const handleClick = (event, participant) => {
    setAnchorEl(event.currentTarget);
    // console.log(participant);
    setMenuParticipant(participant.participant);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleApprove = (participant) => {
    setSelectedParticipant(participant);
    setDialogApproveOpen(true);
    setApproveData({
      participantID: participant,
      approved: true,
      // connectorURL: "",
      // technicalContact: new Person(),
    }); // Reset data
    handleClose();
  };

  const handleDialogApproveClose = () => {
    setDialogApproveOpen(false);
  };

  const handleReject = (participant) => {
    setSelectedParticipant(participant);
    setDialogRejectOpen(true);
    handleClose();
  };

  const handleDialogRejectClose = () => {
    setDialogRejectOpen(false);
    setReason(""); // Clear the reason input
  };

  const handleSuspend = (participant) => {
    setSelectedParticipant(participant);
    setDialogSuspendOpen(true);
    handleClose();
  };

  const handleDialogSuspendClose = () => {
    setDialogSuspendOpen(false);
    setSuspendReason(""); // Clear the reason input
  };

  const handleRequestSuspend = (participant) => {
    setSelectedParticipant(participant);
    setDialogRequestSuspendOpen(true);
    handleClose();
  };

  const handleRequestUnSuspend = (participant) => {
    setSelectedParticipant(participant);
    setDialogRequestUnSuspendOpen(true);
    handleClose();
  };

  const handleRequestWithdraw = (participant) => {
    setSelectedParticipant(participant);
    setDialogRequestWithdrawOpen(true);
    handleClose();
  };

  const handleDialogRequestSuspendClose = () => {
    setDialogRequestSuspendOpen(false);
    setSuspendRequestReason(""); // Clear the reason input
  };

  const handleDialogRequestUnSuspendClose = () => {
    setDialogRequestUnSuspendOpen(false);
    setUnSuspendRequestReason(""); // Clear the reason input
  };

  const handleDialogRequestWithdrawClose = () => {
    setDialogRequestWithdrawOpen(false);
    setWithdrawRequestReason(""); // Clear the reason input
  };

  const handleWithdraw = (participant) => {
    setSelectedParticipant(participant);
    setDialogWithdrawOpen(true);
    handleClose();
  };

  const handleDialogWithdrawClose = () => {
    setDialogWithdrawOpen(false);
    setWithdrawReason(""); // Clear the reason input
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleDelete = () => {
    setSelectedParticipant(menuParticipant); // Store the selected participant for deletion
    setDialogDeleteOpen(true); // Open the confirmation dialog
    handleClose(); // Close the menu after selecting delete
  };

  // Confirm deletion dialog close
  const handleDialogDeleteClose = () => {
    setDialogDeleteOpen(false);
  };

  const handleSuspendReinstateSubmitDialogOpen = () => {
    setSelectedParticipant(menuParticipant); // Store the selected participant for deletion
    setSuspendReinstateDialogOpen(true); // Open the confirmation dialog
    handleClose(); // Close the menu after selecting delete
  };

  // Confirm deletion dialog close
  const handleSuspendReinstateSubmitDialogClose = () => {
    setSuspendReinstateDialogOpen(false);
  };

  const handleWithdrawReinstateSubmitDialogOpen = () => {
    setSelectedParticipant(menuParticipant); // Store the selected participant for deletion
    setWithdrawReinstateDialogOpen(true); // Open the confirmation dialog
    handleClose(); // Close the menu after selecting delete
  };

  // Confirm deletion dialog close
  const handleWithdrawReinstateSubmitDialogClose = () => {
    setWithdrawReinstateDialogOpen(false);
  };

  const handleExport = async () => {
    try {
      const url = `${PARTICIPANT_EXPORT_API}?requested_ids=${rowSelectionModel.join(',')}`;
      const response = await axios.get(url, { responseType: 'blob' });
      if (response.data && response.data.size > 0) {
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'participants.csv';
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+?)"/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1];
          }
        }
        const blobUrl = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

      } else {
        console.warn("No data received for export.");
      }
    } catch (err) {
      console.error("Error during export:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to export participants.";
    }
  };

  const handleSubmitApproval = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        approved: true,
        /* certificate: approveData.publicKey || "", // publicKey from file
        connectorURL: approveData.connectorURL,
        technicalContact: approveData.technicalContact, */
      };
      await axios.put(PARTICIPANT_APPROVAL_API, payload);
      setDialogApproveOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant approved successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during approval:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to approve participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSubmitRejection = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        approved: false,
        reason: reason,
      };
      await axios.put(PARTICIPANT_APPROVAL_API, payload);
      setDialogRejectOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant rejected successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during rejection:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to reject participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSuspendReinstateSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
      };
      await axios.put(PARTICIPANT_UNSUSPEND_API, payload);
      setSuspendReinstateDialogOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant Reinstated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during action:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to Reinstate participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleWithdrawReinstateSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
      };
      await axios.put(PARTICIPANT_REOPEN_API, payload);
      setWithdrawReinstateDialogOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant Reinstated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during action:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to Reinstate participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSubmitSuspend = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: suspendReason,
      };

      await axios.put(PARTICIPANT_SUSPEND_API, payload);
      setDialogSuspendOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant suspended successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error("Error during suspending:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to suspend participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleRequestSuspendSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: suspendRequestReason,
        requested_status: "suspension",
        approved: suspendDecision === "true" ? true : false, // true / or false depends if he want to accept the request or not
      };

      await axios.put(PARTICIPANT_EVALUATE_STATUS_CHANGE_API, payload);
      setDialogRequestSuspendOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant request sent successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error("Error during suspending:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to suspend participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleRequestUnSuspendSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: unSuspendRequestReason,
        requested_status: "undo suspension",
        approved: unSuspendDecision === "true" ? true : false, // true / or false depends if he want to accept the request or not
      };

      await axios.put(PARTICIPANT_EVALUATE_STATUS_CHANGE_API, payload);
      setDialogRequestUnSuspendOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant request sent successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      handleClose();
    } catch (err) {
      console.error("Error during suspending:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to suspend participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };


  const handleRequestWithdrawSubmit = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: withdrawRequestReason,
        requested_status: "withdrawal",
        approved: withdrawDecision === "true" ? true : false, // true / or false depends if he want to accept the request or not
      };
      console.log(payload);
      await axios.put(PARTICIPANT_EVALUATE_STATUS_CHANGE_API, payload);
      setDialogRequestWithdrawOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant request sent successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during termination:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to sent the request.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  const handleSubmitWithdraw = async () => {
    try {
      const payload = {
        participantID: selectedParticipant.id,
        reason: withdrawReason,
      };
      await axios.put(PARTICIPANT_WITHDRAW_API, payload);
      setDialogWithdrawOpen(false);
      await fetchParticipants();
      setSnackbarMessage("Participant withdrawn successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during withdrawing:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to withdraw participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show snackbar on error
    }
  };

  // Function to handle actual deletion request
  const confirmDelete = async () => {
    try {
      await axios.delete(
        `${PARTICIPANT_FORM_SUBMITION}${selectedParticipant.id}/`
      ); // must end with /
      setDialogDeleteOpen(false);
      await fetchParticipants(); // Refresh the participant list after deletion
      setSnackbarMessage("Participant deleted successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Error during deletion:", err);
      const errorMessage =
        parseErrorData(err.response?.data) || "Failed to delete participant.";
      setSnackbarMessage(errorMessage);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  if (loading) {
    return (
      <Paper style={{ padding: "20px", textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="h6">Loading participants...</Typography>
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper
        style={{
          padding: "20px",
          textAlign: "center",
          backgroundColor: "rgba(255, 0, 0, 0.1)",
        }}
      >
        <Typography variant="h6" color="error">
          Error loading participants: {error.message}
        </Typography>
      </Paper>
    );
  }
  // console.log(participants);
  const columns = [
    { field: "id", headerName: "Participant ID", width: 120 },
    {
      field: "name",
      headerName: "Organization Name",
      width: 230,
      valueGetter: (params) => {
        // Ensure params.value is an array
        // console.log(params);
        if (!Array.isArray(params) || params.length === 0) {
          return "Unnamed Participant";
        }
        const filteredNames = params
          .filter((nameObj) => nameObj.language === language)
          .map((nameObj) => nameObj.value);

        return filteredNames.length > 0 ? filteredNames.join(", ") : "Unnamed Participant";
      },
      renderCell: (params) => (
      <>
        {params.row.name.length > 0 ? (
          params.row.name
            .filter((nameObj) => nameObj.language === language)
            .map((nameObj, index) => (
              <Typography
                variant="body2"
                key={index}
                style={{ cursor: "pointer", color: "blue" }}
                onClick={() => handleNameClick(params.row.participant)}
              >
                {nameObj.value}
              </Typography>
            ))
        ) : (
          <Typography variant="body2">Unnamed Participant</Typography>
        )
        }
      </>),
    },
    {
      field: "connector",
      headerName: "Connectors",
      width: 230,
      valueGetter: (params) => {
        // Ensure params.value is an array
        if (!Array.isArray(params) || params.length === 0) {
          return "No connectors";
        }
        // Extract names and join them into a string
        return params.map(connector => connector.name).join(", ");
      },
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "flex-start", flexDirection: "column"}}>
          {params.row.connector.length > 0 ? (
            params.row.connector
              .map((nameObj, index) => (
                <div>
                  <Typography variant="body2" key={index}>
                    {nameObj.name}
                  </Typography>
                </div>
              ))
          ) : (
            <Typography variant="body2">No connectors</Typography>
          )}
        </div>
      ),
    },
    {
      field: "request_status",
      headerName: "Request status",
      width: 230,
      renderCell: (params) => (
          <Chip label={params.row.management.request_status} variant="outlined" color={requestedColors[params.row.management.request_status] || "default"} />
      ),
    },
    {
      field: "approval_status",
      headerName: "Status",
      width: 160,
      renderCell: (params) => (
        <Tooltip title={params.row.management.approval_status === "REJECTED" ? params.row.management.reason : ""} placement="top" arrow>
          <Chip
            label={
              params.row.management.approval_status === "WITHDRAWN"
                ? "TERMINATED"
                : params.row.management.approval_status === "REQUESTED_WITHDRAWAL"
                  ? "REQUESTED_TERMINATION"
                  : params.row.management.approval_status
            }
            color={statusColors[params.row.management.approval_status] || "default"}
          />
        </Tooltip>
      ),
    },
    {
      field: "management",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      valueGetter: (params) => {
        // console.log(params);
        return params.approval_status || "Unknown Status";
      },
      renderCell: (params) => {
        // console.log("Approval Status:", params.row);
        return isAllowedAction(USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY) && (
          <>
            <Button id="basic-button" aria-controls={open ? "basic-menu" : undefined} aria-haspopup="true" aria-expanded={open ? "true" : undefined} onClick={(e) => handleClick(e, params.row)}>
              Actions
            </Button>
            <Menu id="basic-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: "bold", textTransform: "uppercase", color: "text.secondary"}}>
                Manage Status
              </Typography>
              <MenuItem onClick={() => handleApprove(menuParticipant)} disabled={["APPROVED", "REJECTED", "SUSPENDED", "WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <TaskAltIcon fontSize="small" sx={{ pr: 2 }} /> Approve
              </MenuItem>
              <MenuItem onClick={() => handleReject(menuParticipant)} disabled={["APPROVED", "REJECTED", "SUSPENDED", "WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <HighlightOffIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                Reject
              </MenuItem>
              {["APPROVED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleSuspend(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Suspend
                </MenuItem>
              }
              {["REQUESTED_SUSPENSION"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleRequestSuspend(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Accept/Decline Suspension
                </MenuItem>
              }
              {["SUSPENDED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleSuspendReinstateSubmitDialogOpen(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Reinstate to APPROVED
                </MenuItem>
              }
              {// ["SUSPENDED"].includes(menuParticipant?.management?.approval_status) &&
                ["REQUESTED_UNDO_SUSPENSION"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleRequestUnSuspend(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Accept/Decline Unsuspension
                </MenuItem>
              }
              {/* ["WITHDRAWN", "REJECTED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleWithdrawReinstateSubmitDialogOpen(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Reinstate to PENDING
                </MenuItem>
              } */}

              {["REJECTED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleWithdrawReinstateSubmitDialogOpen(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Reinstate to PENDING
                </MenuItem>}

              {["APPROVED", "SUSPENDED"].includes(menuParticipant?.management?.approval_status) &&
                ["NO_REQUEST"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleWithdraw(menuParticipant)}>
                  <RemoveRoadIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Terminate
                </MenuItem>
              }

              {["REQUESTED_WITHDRAWAL"].includes(menuParticipant?.management?.request_status) &&
                <MenuItem onClick={() => handleRequestWithdraw(menuParticipant)}>
                  <PauseCircleOutlineIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                  Accept/Decline Termination
                </MenuItem>
              }

              <Divider sx={{ my: 0.5 }} />
              <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: "bold", textTransform: "uppercase", color: "text.secondary" }}>
                Modify Entry
              </Typography>
              <MenuItem onClick={() => handleDelete(menuParticipant)} disabled={["APPROVED"].includes(menuParticipant?.management?.approval_status)}>
                <DeleteForeverIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                Delete
              </MenuItem>

              <MenuItem onClick={() => handleEdit(menuParticipant)} disabled={["WITHDRAWN"].includes(menuParticipant?.management?.approval_status)}>
                <AppRegistrationIcon fontSize="small" sx={{ pr: 2 }} />{" "}
                Edit form
              </MenuItem>

            </Menu>
          </>
        )
        },
      },
  ];

  const rows = participants.map((participant) => ({
    id: participant.id,
    participant: participant,
    name: participant.name,
    connector: participant.connector,
    approval_status: participant.management.approval_status,
    request_status: participant.management.request_status,
    management: participant.management,
  }));

    return (
        <>
            <TableContainer
                component={Paper}
                style={{ padding: "20px", marginTop: "1em" }}
            >
                <Typography variant="h5" gutterBottom sx={{ mb: 2, mt: 5, color: "#213270" }}>
                    Participant List
                </Typography>
                <Typography variant="body2" gutterBottom sx={{mb: 2, mt: 2}}>
                    View details of all registered participants.
                </Typography>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={5}
                    checkboxSelection
                    onRowSelectionModelChange={(newRowSelectionModel) => {
                      setRowSelectionModel(newRowSelectionModel);
                    }}
                    rowSelectionModel={rowSelectionModel}
                    disableRowSelectionOnClick
                    sx={{
                        "& .MuiDataGrid-cell": {
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                        },
                    }}
                />
                <Button variant="contained" onClick={handleExport} style={{ marginTop: '16px' }}>
                  Export selected participants
                </Button>
                {/* Reject Dialog */}
                <Dialog
                    open={dialogRejectOpen}
                    onClose={handleDialogRejectClose}
                    maxWidth={"lg"}
                >
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>Reject Participant</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">Are you sure you want to reject participant "{selectedParticipant?.name[0]?.value}? "</Typography>
                        <div style={{ paddingTop: "1em" }}>
                            <TextField
                                label="Reason for rejection"
                                fullWidth
                                multiline
                                required
                                rows={3}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogRejectClose} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Tooltip title={reason === "" ? "Please fill out all required fields" : ""} placement="top" arrow >
                            <div>
                                <Button
                                    onClick={handleSubmitRejection}
                                    color="primary"
                                    variant="outlined"
                                    disabled={reason === ""}
                                >
                                    Submit Rejection
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>

                {/* suspend admin Dialog */}
                <Dialog
                    open={dialogSuspendOpen}
                    onClose={handleDialogSuspendClose}
                    maxWidth={"lg"}
                >
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>Suspend participant</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">Are you sure you want to suspend participant"{selectedParticipant?.name[0]?.value}" ?</Typography>
                        <div style={{ paddingTop: "1em" }}>
                            <TextField
                                label="Reason for suspension"
                                fullWidth
                                multiline
                                required
                                rows={3}
                                value={suspendReason}
                                onChange={(e) => setSuspendReason(e.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogSuspendClose} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Tooltip title={suspendReason === "" ? "Please fill out all required fields" : ""} placement="top" arrow>
                            <div><Button
                                onClick={handleSubmitSuspend}
                                color="primary"
                                variant="outlined"
                                disabled={suspendReason === ""}
                            >
                                Submit suspension
                            </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
                {/* suspend On request Dialog */}
                <Dialog
                  open={dialogRequestSuspendOpen}
                  onClose={handleDialogRequestSuspendClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Suspend participant</Typography></DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      Do you want to accept the request for suspension for
                      "<strong>{selectedParticipant?.name[0]?.value}</strong>"?
                    </Typography>

                    {/* Accept or Decline Buttons */}
                    <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                      <Button
                        variant={suspendDecision === "true" ? "contained" : "outlined"}
                        color="success"
                        onClick={() => setSuspendDecision("true")}
                      >
                        Accept Suspension
                      </Button>
                      <Button
                        variant={suspendDecision === "false" ? "contained" : "outlined"}
                        color="error"
                        onClick={() => setSuspendDecision("false")}
                      >
                        Decline Suspension
                      </Button>
                    </div>

                    {/* Reason Input (only shown when a suspendDecision is made) */}
                    {suspendDecision && (
                      <div style={{ paddingTop: "1em" }}>
                        <TextField
                          label={`Reason for ${suspendDecision === "true" ? "accepting" : "declining"} suspension`}
                          fullWidth
                          multiline
                          required
                          rows={3}
                          value={suspendRequestReason}
                          onChange={(e) => setSuspendRequestReason(e.target.value)}
                          // error={!suspendRequestReason && submitted} // Show error if submitted without a reason
                          helperText={!suspendRequestReason ? "Reason is required" : ""}
                        />
                      </div>
                    )}
                    <DialogActions>
                      {/* Confirm Button (only enabled when a reason is provided) */}
                        <Button onClick={handleDialogRequestSuspendClose} color="primary" variant="outlined">
                          Cancel
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleRequestSuspendSubmit}
                          disabled={!suspendDecision || !suspendRequestReason} // Disable if no suspendDecision or no reason
                        >
                          Confirm
                        </Button>
                    </DialogActions>
                  </DialogContent>
                </Dialog>
                {/* suspend On request Dialog */}
                <Dialog
                  open={dialogRequestUnSuspendOpen}
                  onClose={handleDialogRequestUnSuspendClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Unsuspend participant</Typography></DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      Do you want to accept the request for unsuspension for
                      "<strong>{selectedParticipant?.name[0]?.value}</strong>"?
                    </Typography>

                    {/* Accept or Decline Buttons */}
                    <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                      <Button
                        variant={unSuspendDecision === "true" ? "contained" : "outlined"}
                        color="success"
                        onClick={() => setUnSuspendDecision("true")}
                      >
                        Accept Unsuspension
                      </Button>
                      <Button
                        variant={unSuspendDecision === "false" ? "contained" : "outlined"}
                        color="error"
                        onClick={() => setUnSuspendDecision("false")}
                      >
                        Decline Unsuspension
                      </Button>
                    </div>

                    {/* Reason Input (only shown when a unSuspendDecision is made) */}
                    {unSuspendDecision && (
                      <div style={{ paddingTop: "1em" }}>
                        <TextField
                          label={`Reason for ${unSuspendDecision === "true" ? "accepting" : "declining"} unsuspension`}
                          fullWidth
                          multiline
                          required
                          rows={3}
                          value={unSuspendRequestReason}
                          onChange={(e) => setUnSuspendRequestReason(e.target.value)}
                          // error={!suspendRequestReason && submitted} // Show error if submitted without a reason
                          helperText={!unSuspendRequestReason ? "Reason is required" : ""}
                        />
                      </div>
                    )}
                    <DialogActions>
                      {/* Confirm Button (only enabled when a reason is provided) */}
                        <Button onClick={handleDialogRequestUnSuspendClose} color="primary" variant="outlined">
                          Cancel
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleRequestUnSuspendSubmit}
                          disabled={!unSuspendDecision || !unSuspendRequestReason} // Disable if no suspendDecision or no reason
                        >
                          Confirm
                        </Button>
                    </DialogActions>
                  </DialogContent>
                </Dialog>
                {/* withdraw Dialog */}
                <Dialog
                    open={dialogWithdrawOpen}
                    onClose={handleDialogWithdrawClose}
                    maxWidth={"lg"}
                >
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>Terminate participant</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">Are you sure you want to terminate participant "{selectedParticipant?.name[0]?.value}" ?</Typography>
                        <div style={{ paddingTop: "1em" }}>
                            <TextField
                                label="Reason for terminations"
                                fullWidth
                                multiline
                                required
                                rows={3}
                                value={withdrawReason}
                                onChange={(e) => setWithdrawReason(e.target.value)}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogWithdrawClose} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Tooltip title={withdrawReason === "" ? "Please fill out all required fields" : ""} placement="top" arrow >
                            <div>
                                <Button
                                    onClick={handleSubmitWithdraw}
                                    color="primary"
                                    variant="outlined"
                                    disabled={withdrawReason === ""}
                                >
                                    Submit termination
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
                {/* withdraw On request Dialog */}
                <Dialog
                  open={dialogRequestWithdrawOpen}
                  onClose={handleDialogRequestWithdrawClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Request to terminate participant</Typography></DialogTitle>
                  <DialogContent>
                    <Typography variant="body1">
                      Do you want to accept the request for termination for
                      "<strong>{selectedParticipant?.name[0]?.value}</strong>"?
                    </Typography>

                    {/* Accept or Decline Buttons */}
                    <div style={{ display: "flex", gap: "1em", marginTop: "1em" }}>
                      <Button
                        variant={withdrawDecision === "true" ? "contained" : "outlined"}
                        color="success"
                        onClick={() => setWithdrawDecision("true")}
                      >
                        Accept termination
                      </Button>
                      <Button
                        variant={withdrawDecision === "false" ? "contained" : "outlined"}
                        color="error"
                        onClick={() => setWithdrawDecision("false")}
                      >
                        Decline termination
                      </Button>
                    </div>

                    {/* Reason Input (only shown when a withdrawDecision is made) */}
                    {withdrawDecision && (
                      <div style={{ paddingTop: "1em" }}>
                        <TextField
                          label={`Reason for ${withdrawDecision === "true" ? "accepting" : "declining"} withdrawal`}
                          fullWidth
                          multiline
                          required
                          rows={3}
                          value={withdrawRequestReason}
                          onChange={(e) => setWithdrawRequestReason(e.target.value)}
                          // error={!withdrawRequestReason && submitted} // Show error if submitted without a reason
                          helperText={!withdrawRequestReason ? "Reason is required" : ""}
                        />
                      </div>
                    )}
                    <DialogActions>
                      {/* Confirm Button (only enabled when a reason is provided) */}
                      <Button onClick={handleDialogRequestWithdrawClose} color="primary" variant="outlined">
                        Cancel
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleRequestWithdrawSubmit}
                        disabled={!withdrawDecision || !withdrawRequestReason} // Disable if no withdrawDecision or no reason
                      >
                        Confirm
                      </Button>
                    </DialogActions>
                  </DialogContent>
                </Dialog>
                {/* Approval Dialog */}
                <Dialog
                  open={dialogApproveOpen}
                  onClose={handleDialogApproveClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Approve participant</Typography></DialogTitle>
                  <DialogContent>
                    <div stle={{ padding: 2 }}>
                      <Typography variant="body1">Are you sure you want to approve participant "{selectedParticipant?.name[0]?.value}"" ?</Typography>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleDialogApproveClose} color="primary" variant="outlined">Cancel</Button>
                    <Button onClick={handleSubmitApproval} color="primary" variant="outlined">Submit Approval</Button>
                  </DialogActions>
                </Dialog>

                {/* Reinstate suspended Dialog */}
                <Dialog
                  open={suspendReinstateDialogOpen}
                  onClose={handleSuspendReinstateSubmitDialogClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Reinstate (Approve) participant</Typography></DialogTitle>
                  <DialogContent>
                    <div stle={{ padding: 2 }}>
                      <Typography variant="body1">Are you sure you want to reinstate participant "{selectedParticipant?.name[0]?.value}"" ?</Typography>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleSuspendReinstateSubmitDialogClose} color="primary" variant="outlined">Cancel</Button>
                    <Button onClick={handleSuspendReinstateSubmit} color="primary" variant="outlined">Submit</Button>
                  </DialogActions>
                </Dialog>

                {/* Reinstate withdraw Dialog */}
                <Dialog
                  open={withdrawReinstateDialogOpen}
                  onClose={handleWithdrawReinstateSubmitDialogClose}
                  maxWidth={"lg"}
                >
                  <DialogTitle><Typography variant="h6" sx={{ fontWeight: 600 }}>Reinstate (back to pending) participant</Typography></DialogTitle>
                  <DialogContent>
                    <div stle={{ padding: 2 }}>
                      <Typography variant="body1">Are you sure you want to reinstate participant "{selectedParticipant?.name[0]?.value}"" ?</Typography>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleWithdrawReinstateSubmitDialogClose} color="primary" variant="outlined">Cancel</Button>
                    <Button onClick={handleWithdrawReinstateSubmit} color="primary" variant="outlined">Submit</Button>
                  </DialogActions>
                </Dialog>

                {/* Participant Details Dialog */}
                <ParticipantDetailsDialog
                    open={detailsDialogOpen}
                    onClose={handleDetailsDialogClose}
                    participant={selectedParticipantObj}
                    onEdit={handleEdit}
                    mappings={schemaAsObject.$defs}
                    schemaAsObject={schemaAsObject}
                />

                {/* Delete confirmation dialog */}
                <Dialog open={dialogDeleteOpen} onClose={handleDialogDeleteClose}>
                    <DialogTitle><Typography variant="h6" sx={{fontWeight: 600}}>Delete participant</Typography></DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">Are you sure you want to delete participant "{selectedParticipant?.name[0]?.value}" ?</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogDeleteClose} variant="outlined">Cancel</Button>
                        <Button onClick={confirmDelete} color="error" variant="outlined">Delete</Button>
                    </DialogActions>
                </Dialog>
            </TableContainer>

            {/* Snackbar Component */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ParticipantList;
